import { OPTION_TYPE } from "Common/dictionaries/optionType";
import last from "lodash/last";
import map from "lodash/map";
import sortBy from "lodash/sortBy";
import includes from "lodash/includes";
import filter from "lodash/filter";
import { compareStrings } from "Utils";
export default (node, documentObject) => {
    var _a, _b, _c, _d, _e;
    if (!node || !documentObject || !documentObject.Attributes)
        return "";
    const stringAttr = filter(documentObject.Attributes, ["Type", OPTION_TYPE.STRING]);
    const stringAttrText = (_b = (_a = stringAttr.find(item => compareStrings(item.Name, "Text"))) === null || _a === void 0 ? void 0 : _a.Key) !== null && _b !== void 0 ? _b : (_c = stringAttr.find(item => compareStrings(item.Name, "Content"))) === null || _c === void 0 ? void 0 : _c.Key;
    if (stringAttrText) {
        const value = (_e = (_d = node.AttributeValues) === null || _d === void 0 ? void 0 : _d.find(item => item.Key === stringAttrText)) === null || _e === void 0 ? void 0 : _e.Value;
        if (value)
            return `${value}`;
    }
    const stringAttrIds = map(stringAttr, "Key");
    const strings = map(filter(node.AttributeValues, (av) => includes(stringAttrIds, av.Key)), "Value");
    const longest = last(sortBy(strings, ["length"]));
    return `${longest}`;
};
